export default "__VITE_ASSET__BvMQA82S__"